module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Recover @.lower:loginName","messages":{"successTitle":"Email sent","successMsg":"Please recover the @.low:loginName according to the email"}},"zh_hk":{"title":"恢復@:loginName","messages":{"successTitle":"郵件已發送","successMsg":"請根據電子郵件恢復@:loginName"}},"zh_cn":{"title":"恢复@:loginName","messages":{"successTitle":"邮件已发送","successMsg":"请根据电子邮件恢复@:loginName"}}}')
  delete Component.options._Ctor
}
